"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-header kiwi-theme-bg",
    class: {
      'kiwi-header--channel': _vm.isChannel(),
      'kiwi-header--query': _vm.isQuery(),
      'kiwi-header--server': _vm.isServer(),
      'kiwi-header--special': _vm.isSpecial()
    },
    on: {
      "click": _vm.onHeaderClick
    }
  }, [_vm.isChannel() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(_vm._s(_vm.buffer.name) + " ")])]), _c('div', {
    staticClass: "kiwi-header-center"
  }, [_vm.shouldShowTopic ? _c('div', {
    staticClass: "kiwi-header-topic",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTopic)
    }
  }) : _vm._e()]), _vm.isJoined && _vm.isConnected ? _c('div', {
    key: _vm.buffer.id,
    staticClass: "kiwi-header-options"
  }, [_vm.queryBuffers.length ? _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-query-switcher"
  }, [_c('a', {
    attrs: {
      "title": "Privados abiertos"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleQuerySwitcher.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.queryBuffers.length))])]), _vm.showQuerySwitcher ? _c('div', {
    staticClass: "kiwi-header-query-menu",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-header-query-menu-title"
  }, [_vm._v(" Privados abiertos ")]), _vm._l(_vm.queryBuffers, function (query) {
    return _c('button', {
      key: query.name,
      staticClass: "kiwi-header-query-menu-item",
      class: {
        'kiwi-header-query-menu-item--active': query.name === _vm.buffer.name && _vm.isQuery()
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openQueryBuffer(query);
        }
      }
    }, [_c('span', {
      staticClass: "kiwi-header-query-menu-avatar"
    }, [_vm._v(" " + _vm._s(query.name.charAt(0).toUpperCase()) + " ")]), _c('span', {
      staticClass: "kiwi-header-query-menu-name"
    }, [_vm._v(" " + _vm._s(query.name) + " ")]), (0, _flags.default)(query) && (0, _flags.default)(query).unread ? _c('span', {
      staticClass: "kiwi-header-query-menu-unread"
    }, [_vm._v(" 💬 " + _vm._s(_vm.unreadLabel((0, _flags.default)(query).unread)) + " ")]) : _vm._e(), _c('span', {
      staticClass: "kiwi-header-query-menu-close",
      attrs: {
        "title": "Cerrar privado"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.closeSpecificQueryBuffer(query);
        }
      }
    }, [_vm._v(" × ")])]);
  })], 2) : _vm._e()]) : _vm._e(), _vm.areWeAnOp ? _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-operator",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'settings'
    }
  }, [_c('a', {
    attrs: {
      "title": "Herramientas de operador"
    },
    on: {
      "click": _vm.openOperatorTools
    }
  }, [_c('i', {
    staticClass: "fa fa-shield-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-settings",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'settings'
    }
  }, [_c('a', {
    attrs: {
      "title": _vm.$t('channel_settings')
    },
    on: {
      "click": function click($event) {
        return _vm.sidebarState.toggleBufferSettings();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-nicklist",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'nicklist' || _vm.sidebarSection === 'user'
    }
  }, [_c('a', {
    attrs: {
      "title": _vm.$t('person', {
        count: (0, _keys.default)(_vm.buffer.users).length
      })
    },
    on: {
      "click": function click($event) {
        return _vm.sidebarState.toggleNicklist();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s((0, _keys.default)(_vm.buffer.users).length))])])]), _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-about",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'about'
    }
  }, [_c('a', {
    attrs: {
      "title": _vm.$t('more_information')
    },
    on: {
      "click": function click($event) {
        return _vm.sidebarState.toggleAbout();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._l(_vm.pluginUiChannelElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "kiwi-header-option",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer,
          containerheader: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  })], 2) : _vm._e(), !_vm.isJoined && _vm.isConnected ? _c('div', {
    staticClass: "kiwi-header-notjoined"
  }, [_c('a', {
    staticClass: "u-link kiwi-header-join-channel-button",
    on: {
      "click": _vm.joinCurrentBuffer
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('container_join')) + " ")])]) : _vm._e()] : _vm.isServer() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_vm._v(_vm._s(_vm.serverHeaderName))]), _vm._v(" " + _vm._s(_vm.serverHeaderName) + " ")])]), _c('div', {
    staticClass: "kiwi-header-center"
  }), _c('div', {
    staticClass: "kiwi-header-server-connection"
  }, [_vm.buffer.getNetwork().state === 'disconnected' ? _c('a', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": _vm.onConnectButtonClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('connect')) + " ")]) : _vm.buffer.getNetwork().state === 'connecting' ? _c('span', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('connecting')) + " ")]) : _vm._e()])] : _vm.isQuery() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_c('away-status-indicator', {
    staticClass: "kiwi-header-awaystatus",
    attrs: {
      "network": _vm.buffer.getNetwork(),
      "user": _vm.network.userByName(_vm.buffer.name)
    }
  }), _vm._v(_vm._s(_vm.buffer.name) + " ")], 1), _c('away-status-indicator', {
    staticClass: "kiwi-header-awaystatus",
    attrs: {
      "network": _vm.buffer.getNetwork(),
      "user": _vm.network.userByName(_vm.buffer.name)
    }
  }), _vm._v(_vm._s(_vm.buffer.name) + " ")], 1)]), _c('div', {
    staticClass: "kiwi-header-center"
  }), _c('div', {
    key: _vm.buffer.id,
    staticClass: "kiwi-header-options"
  }, [_vm.queryBuffers.length ? _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-query-switcher"
  }, [_c('a', {
    attrs: {
      "title": "Privados abiertos"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleQuerySwitcher.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.queryBuffers.length))])]), _vm.showQuerySwitcher ? _c('div', {
    staticClass: "kiwi-header-query-menu",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-header-query-menu-title"
  }, [_vm._v(" Privados abiertos ")]), _vm._l(_vm.queryBuffers, function (query) {
    return _c('button', {
      key: query.name,
      staticClass: "kiwi-header-query-menu-item",
      class: {
        'kiwi-header-query-menu-item--active': query.name === _vm.buffer.name && _vm.isQuery()
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openQueryBuffer(query);
        }
      }
    }, [_c('span', {
      staticClass: "kiwi-header-query-menu-avatar"
    }, [_vm._v(" " + _vm._s(query.name.charAt(0).toUpperCase()) + " ")]), _c('span', {
      staticClass: "kiwi-header-query-menu-name"
    }, [_vm._v(" " + _vm._s(query.name) + " ")]), (0, _flags.default)(query) && (0, _flags.default)(query).unread ? _c('span', {
      staticClass: "kiwi-header-query-menu-unread"
    }, [_vm._v(" 💬 " + _vm._s(_vm.unreadLabel((0, _flags.default)(query).unread)) + " ")]) : _vm._e(), _c('span', {
      staticClass: "kiwi-header-query-menu-close",
      attrs: {
        "title": "Cerrar privado"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.closeSpecificQueryBuffer(query);
        }
      }
    }, [_vm._v(" × ")])]);
  })], 2) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-minimize-query"
  }, [_c('a', {
    attrs: {
      "title": "Minimizar privado"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.minimizeQueryBuffer.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Minimizar")])])]), _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-close-query"
  }, [_c('a', {
    attrs: {
      "title": "Cerrar privado"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeQueryBuffer.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Cerrar")])])]), _vm.userOnline ? _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-user",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'user'
    }
  }, [_c('a', {
    on: {
      "click": function click($event) {
        return _vm.toggleUser();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._l(_vm.pluginUiQueryElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "kiwi-header-option",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer,
          containerheader: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  })], 2)] : _vm.isSpecial() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(" " + _vm._s(_vm.buffer.name) + " ")])]), _c('div', {
    staticClass: "kiwi-header-center"
  }), _c('div', {
    staticClass: "kiwi-header-options"
  })] : _vm._e()], 2);
};
var staticRenderFns = exports.staticRenderFns = [];